import { Component } from '@angular/core';
import { DataGridColumn } from 'src/app/utils/interfaces';

@Component({
  selector: 'acs-theme-configuration',
  templateUrl: './theme-configuration.html',
  styleUrls: ['./theme-configuration.scss']
})
export class ThemeConfiguruationComponent {
  isLoading = false;
  showModal = false;

  // Sample data for data grid demo
  gridData = [
    { id: 1, name: 'Chapter Alpha', location: 'New York, NY', members: 245, status: 'Active', founded: '2010-03-15', lastMeeting: '2024-01-15', president: 'John Smith', budget: 125000, region: 'Northeast', type: 'Professional', certification: 'Gold' },
    { id: 2, name: 'Chapter Beta', location: 'Los Angeles, CA', members: 189, status: 'Active', founded: '2012-07-22', lastMeeting: '2024-01-10', president: 'Sarah Johnson', budget: 98000, region: 'West', type: 'Student', certification: 'Silver' },
    { id: 3, name: 'Chapter Gamma', location: 'Chicago, IL', members: 167, status: 'Inactive', founded: '2015-11-08', lastMeeting: '2023-12-20', president: 'Michael Brown', budget: 75000, region: 'Midwest', type: 'Professional', certification: 'Bronze' },
    { id: 4, name: 'Chapter Delta', location: 'Houston, TX', members: 203, status: 'Active', founded: '2009-05-12', lastMeeting: '2024-01-12', president: 'Lisa Garcia', budget: 110000, region: 'South', type: 'Professional', certification: 'Gold' },
    { id: 5, name: 'Chapter Epsilon', location: 'Phoenix, AZ', members: 156, status: 'Active', founded: '2018-02-28', lastMeeting: '2024-01-08', president: 'David Wilson', budget: 85000, region: 'West', type: 'Mixed', certification: 'Silver' }
  ];

  gridColumns: DataGridColumn[] = [
    { key: 'name', label: 'Chapter Name', sortable: true, filterable: true, width: '200px' },
    { key: 'location', label: 'Location', sortable: true, filterable: true, width: '180px' },
    { key: 'members', label: 'Members', sortable: true, type: 'number', align: 'center', width: '100px' },
    { key: 'status', label: 'Status', sortable: true, filterable: true, width: '120px', format: (value: string) => this.getDemoStatusDisplay(value) },
    { key: 'president', label: 'President', sortable: true, filterable: true, width: '150px' },
    { key: 'budget', label: 'Budget', sortable: true, type: 'number', align: 'right', width: '120px', format: (value) => '$' + value.toLocaleString() },
    { key: 'region', label: 'Region', sortable: true, filterable: true, width: '110px' },
    { key: 'type', label: 'Type', sortable: true, filterable: true, width: '110px' },
    { key: 'certification', label: 'Certification', sortable: true, filterable: true, width: '130px' },
    { key: 'founded', label: 'Founded', sortable: true, type: 'date', width: '120px' },
    { key: 'lastMeeting', label: 'Last Meeting', sortable: true, type: 'date', width: '130px' }
  ];

  handleButtonClick(): void {
    console.log('Button clicked!');
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  }

  onGridRowClick(item: any): void {
    console.log('Grid row clicked:', item);
  }

  onGridSelectionChange(selection: any[]): void {
    console.log('Grid selection changed:', selection);
  }

  onGridExport(exportOptions: any): void {
    console.log('Exporting data:', exportOptions);
    alert(`Exporting ${exportOptions.selectedOnly ? 'selected' : 'all'} data to ${exportOptions.format.toUpperCase()} format`);
  }

  openModal(): void {
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
  }

  getDemoStatusDisplay(status: string): string {
    return status;
  }
}